<template>
  <div class="contents contents--pt">
    <section v-if="!changePasswordSuccess" class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <div v-show="errorMessage" class="Form__input_box Form__input_box--md">
            <label class="Form__error_tx">{{ errorMessage }}</label>
          </div>
          <div :class="`Form__input_box Form__input_box--md ${$v.form.password.$error ? '_error' : ''}`">
            <p class="Form__input_heda">
              新しいパスワード
            </p>
            <input
              v-model="$v.form.password.$model"
              class="Form__input"
              placeholder="10文字以上で設定してください"
              type="password"
            >
            <div class="Form__error_box">
              <div class="Form__error_tx">
                <label v-if="!$v.form.password.required">パスワードを入力してください</label>
              </div>
              <div class="Form__error_tx">
                <label v-if="!$v.form.password.minLength">10文字以上で設定してください</label>
              </div>
              <div class="Form__error_tx">
                <label v-if="!$v.form.password.regexPassword">数字、英字を含めて設定してください</label>
              </div>
            </div>
          </div>
          <div
            :class="`Form__input_box Form__input_box--md Form__input_box--mt_md  ${($v.form.confirm_password.$error) ? '_error' : ''}`"
          >
            <p class="Form__input_heda">
              新しいパスワード（確認用）
            </p>
            <input
              v-model="$v.form.confirm_password.$model"
              class="Form__input"
              placeholder="*********"
              type="password"
            >
            <div class="Form__error_box">
              <div class="Form__error_tx">
                <label v-if="!$v.form.confirm_password.required">パスワードの確認が必要です</label>
              </div>
              <div class="Form__error_tx">
                <label v-if="!$v.form.confirm_password.sameAsPassword">パスワードの確認はパスワードと同じである必要があります</label>
              </div>
            </div>
          </div>
          <button :disabled="$v.form.$invalid || isLoading" class="Btn__blue Form__btn--mt_lg" @click="onSubmit">
            変更する
          </button>
        </div>
      </div>
    </section>
    <section v-else class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <img alt="ok" class="Form__thank_img" src="assets/img/thank.png">
          <p class="Form__tx _ft-cnt">
            パスワードの変更が完了しました。
          </p>
          <router-link class="Btn__blue Form__btn--mt_md Form__btn--mt_sp_sm" to="/signin">
            ログインはこちら
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { minLength, required, sameAs } from 'vuelidate/lib/validators'
import authService from '@/services/authService'
import { regexPassword } from '@/helpers/validations'

export default {
  name: 'ChangePassword',
  mixins: [validationMixin],
  data() {
    return {
      changePasswordSuccess: false,
      isLoading: false,
      form: {
        password: '',
        confirm_password: '',
        token: ''
      },
      errorMessage: ''
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(10),
        regexPassword
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  mounted() {
    if (this.$route.query.token) {
      this.form.token = this.$route.query.token
    } else {
      this.$router.push('page404')
    }
  },
  methods: {
    onSubmit() {
      this.isLoading = true
      authService.changePassword(this.form).then(() => {
        this.changePasswordSuccess = true
      }).catch((error) => {
        this.errorMessage = error.data.message
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
